const ConsentTypeConstants = {
  SUBSCRIPTION_STATUS_FOR_NEW_CONNECTION: 'new',
  CONSENTED_SOURCE: 'marketplace'
};

export default ConsentTypeConstants;
